<div class="editorial-astrea">

    <mat-drawer-container class="astrea-container">

        <section class="astrea-header">
            <mat-toolbar>
                <astrea-menu-navbar
                    (handleMenu)="handleMenu()"
                ></astrea-menu-navbar>
            </mat-toolbar>
        </section>

        <section class="astrea-content">
            <router-outlet></router-outlet>
        </section>

        <br>

        <section>
            <astrea-footer></astrea-footer>
        </section>

        <!-- Menu Mobile -->
        <mat-drawer #sidenav [mode]="'over'">
            <astrea-menu-leftnav
                (handleMenu)="handleMenu()"
            ></astrea-menu-leftnav>
        </mat-drawer>

    </mat-drawer-container>

    <div class="av">
        <a href="https://astreavirtual.com" class="d-flex a-i-center" title="Ir a Astrea Virtual">
            <img src="/assets/images/astrea-brand/av_isologo.svg" alt="Logo Astrea Virtual" />
            Ir a Astrea Virtual
        </a>
    </div>

    <div class="whatsapp">
        <a href="https://wa.me/5491126827008?text=Hola%2C%20me%20brindan%20m%C3%A1s%20informaci%C3%B3n%20de%20la%20obra%20%E2%80%A6" target="_blank" title="Contactate por WhatsApp">
            <img src="/assets/images/whatsapp-logo.png" alt="Logo WhatsApp" />
        </a>
    </div>

    <div *ngIf="devMode != 'production'" class="development-mode">
        <p>Development</p>
    </div>

</div>
